import { interviewContent, ambassadorPortrait } from './interview';
import { caureInterview, caureHeroPhoto } from './caureInterview';

// Registre des entretiens publiés — ajouter ici les prochaines interviews
export const interviewsIndex = [
  {
    slug: '/interview-vincent-caure',
    photo: caureHeroPhoto.src,
    photoPosition: 'object-[center_25%]',
    person: 'Vincent Caure',
    date: { fr: 'Riga — Septembre 2026', en: 'Riga — September 2026', lv: 'Rīga — 2026. gada septembris' },
    role: {
      fr: 'Député des Français établis hors de France · Président de la Commission des lois',
      en: 'Member of the National Assembly for French citizens abroad · Chair of the Law Committee',
      lv: 'Ārvalstīs dzīvojošo Francijas pilsoņu deputāts · Likumu komisijas priekšsēdētājs',
    },
    title: {
      fr: caureInterview.fr.teaser.title,
      en: caureInterview.en.teaser.title,
      lv: caureInterview.lv.teaser.title,
    },
    excerpt: {
      fr: caureInterview.fr.teaser.summary,
      en: caureInterview.en.teaser.summary,
      lv: caureInterview.lv.teaser.summary,
    },
    isNew: true,
  },
  {
    slug: '/interview-ambassadeur',
    photo: ambassadorPortrait,
    photoPosition: 'object-top',
    person: 'Manuel Lafont Rapnouil',
    date: { fr: 'Riga — Mars 2026', en: 'Riga — March 2026', lv: 'Rīga — 2026. gada marts' },
    role: {
      fr: interviewContent.fr.role,
      en: interviewContent.en.role,
      lv: interviewContent.lv.role,
    },
    title: {
      fr: 'Relation économique franco-lettone : la vision de l’Ambassadeur de France',
      en: 'The Franco-Latvian economic relationship: the view of the French Ambassador',
      lv: 'Francijas un Latvijas ekonomiskās attiecības: Francijas vēstnieka skatījums',
    },
    excerpt: {
      fr: interviewContent.fr.teaserIntro,
      en: interviewContent.en.teaserIntro,
      lv: interviewContent.lv.teaserIntro,
    },
    isNew: false,
  },
];

export const interviewsPageContent = {
  fr: {
    navLabel: 'Entretiens',
    navAll: 'Tous les entretiens',
    eyebrow: 'Rubrique',
    title: 'Entretiens',
    subtitle:
      'Les grands témoins de la relation franco-lettone répondent aux questions du Business Club France Latvia : diplomates, élus, entrepreneurs et décideurs économiques.',
    count: (n) => `${n} entretien${n > 1 ? 's' : ''} publié${n > 1 ? 's' : ''}`,
    read: 'Lire l’entretien',
    badgeNew: 'Nouveau',
    ctaBack: 'Retour à l’accueil',
    seoTitle: 'Entretiens | Business Club France–Latvia',
    seoDescription:
      'Retrouvez tous les entretiens du Business Club France Latvia : ambassadeurs, parlementaires et acteurs économiques sur la relation France–Lettonie.',
  },
  en: {
    navLabel: 'Interviews',
    navAll: 'All interviews',
    eyebrow: 'Section',
    title: 'Interviews',
    subtitle:
      'Key voices of the Franco-Latvian relationship answer the Business Club France Latvia’s questions: diplomats, elected officials, entrepreneurs and business leaders.',
    count: (n) => `${n} interview${n > 1 ? 's' : ''} published`,
    read: 'Read the interview',
    badgeNew: 'New',
    ctaBack: 'Back to home',
    seoTitle: 'Interviews | Business Club France–Latvia',
    seoDescription:
      'All Business Club France Latvia interviews: ambassadors, members of parliament and business leaders on the France–Latvia relationship.',
  },
  lv: {
    navLabel: 'Intervijas',
    navAll: 'Visas intervijas',
    eyebrow: 'Sadaļa',
    title: 'Intervijas',
    subtitle:
      'Francijas un Latvijas attiecību nozīmīgākās personības atbild uz Business Club France Latvia jautājumiem: diplomāti, politiķi, uzņēmēji un ekonomikas lēmumu pieņēmēji.',
    count: (n) => `${n} publicēta${n > 1 ? 's' : ''} intervija${n > 1 ? 's' : ''}`,
    read: 'Lasīt interviju',
    badgeNew: 'Jaunums',
    ctaBack: 'Atpakaļ uz sākumu',
    seoTitle: 'Intervijas | Business Club France–Latvia',
    seoDescription:
      'Visas Business Club France Latvia intervijas: vēstnieki, parlamentārieši un ekonomikas dalībnieki par Francijas un Latvijas attiecībām.',
  },
};

export default interviewsIndex;
